"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_2 = require("react");
var react_i18next_1 = require("react-i18next");
var EmptyGameList_1 = __importDefault(require("./components/game/EmptyGameList"));
var GameList_1 = __importDefault(require("./components/game/GameList"));
var Search_1 = __importDefault(require("./components/Search"));
var Alphabet = function () {
    var alphabet = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];
    var _a = (0, react_i18next_1.useTranslation)(), t = _a.t, i18n = _a.i18n;
    var _b = (0, react_1.useState)(alphabet /*["a", "b", "c"]*/), alphabetView = _b[0], setAlphabetView = _b[1];
    var _c = (0, react_1.useState)([]), gameList = _c[0], setGameList = _c[1];
    var _d = (0, react_1.useState)(false), eventSearchClcick = _d[0], setEventSearchClcick = _d[1];
    function handleClick(value) {
        setAlphabetView([value]);
        setEventSearchClcick(true);
    }
    function handleBackClick() {
        setEventSearchClcick(false);
        setAlphabetView(alphabet);
    }
    function handleOnSearchChange(value) {
        if (value.length == 0) {
            setAlphabetView(['a']);
        }
        else {
            setAlphabetView([value]);
        }
    }
    (0, react_1.useEffect)(function () {
        axios_1.default.get("/app/game/list")
            .then(function (response) {
            setGameList(response.data);
        });
    }, []);
    return (react_1.default.createElement(react_2.Fragment, null,
        react_1.default.createElement("div", { className: "wrap-caption-game" },
            react_1.default.createElement("h3", { className: "block-caption-game" }, t("page.index.list.all_game")),
            react_1.default.createElement("div", { className: "__alphabet-wrap-input-small" },
                react_1.default.createElement("input", { placeholder: t("page.index.list.search.placeholder"), onChange: function (e) { return handleOnSearchChange(e.target.value); }, className: "__alphabet-input-search" }),
                react_1.default.createElement("img", { alt: t("page.index.alphabet.search.img.alt"), className: "__alphabet-input-search-icon", src: "/images/web/search.svg", style: { height: "32px", width: "32px" } }))),
        react_1.default.createElement("div", { className: "alphabet-wrap-conteiner" },
            react_1.default.createElement("div", { className: "__alphabet-wrap-link" }, alphabet.map(function (item, index) {
                return react_1.default.createElement("span", { className: (0, classnames_1.default)((alphabetView.length === 1 && alphabetView[0] == item) ? "__selected" : ""), key: index, onClick: function () { return handleClick(item); } }, item);
            })),
            react_1.default.createElement(Search_1.default, { onChange: handleOnSearchChange })),
        react_1.default.createElement("div", { className: "game-wrap-conteiner" }, alphabetView.map(function (item, index) {
            var subList = gameList.filter(function (value) { return value.name.toLocaleLowerCase().startsWith(item); });
            if (subList.length) {
                return react_1.default.createElement(GameList_1.default, { onBackClick: handleBackClick, isViewButton: eventSearchClcick, key: index, caption: item, list: subList });
            }
            else {
                if (eventSearchClcick) {
                    return react_1.default.createElement(EmptyGameList_1.default, { onBackClick: handleBackClick, key: index, caption: item });
                }
            }
            return "";
        } /*<GameList key={index} caption={item}  />*/))));
};
exports.default = Alphabet;
